const navigatorErrorMessage =
  'Could not find `userAgent` or `userAgentData` window.navigator properties to set `os`, `browser` and `version`';
const removeExcessMozillaAndVersion = /^mozilla\/\d\.\d\W/;
const browserPattern = /(\w+)\/(\d+\.\d+(?:\.\d+)?(?:\.\d+)?)/g;
const engineAndVersionPattern = /^(ver|cri|gec)/;
const brandList = ['chrome', 'opera', 'safari', 'edge', 'firefox'];
const unknown = 'Unknown';
const empty = '';
const { isArray } = Array;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let userAgentData = (window.navigator as any).userAgentData;
let userAgent = window.navigator.userAgent;

const mobiles: { [key: string]: RegExp } = {
  iphone: /iphone/,
  ipad: /ipad|macintosh/,
  android: /android/
};

const desktops: { [key: string]: RegExp } = {
  windows: /win/,
  mac: /macintosh/,
  linux: /linux/
};

export const detectPlatform = (customUserAgent?: unknown, customUserAgentData?: unknown) => {
  // Use a provided UA string instead of the browser's UA
  userAgent = typeof customUserAgent === 'string' ? customUserAgent : userAgent;

  // Use a provided UA data string instead of the browser's UA data
  userAgentData = typeof customUserAgentData === 'string' ? customUserAgentData : userAgentData;

  if (userAgent) {
    const ua = userAgent.toLowerCase().replace(removeExcessMozillaAndVersion, empty);

    // Determine the operating system.
    const mobileOS = Object.keys(mobiles).find(o => mobiles[o].test(ua) && window.navigator.maxTouchPoints >= 1);
    const desktopOS = Object.keys(desktops).find(o => desktops[o].test(ua));
    const os = mobileOS ?? desktopOS;

    // Extract browser and version information.
    const browserTest = ua.match(browserPattern);
    const versionRegex = /version\/(\d+(\.\d+)*)/;
    const safariVersion = RegExp(versionRegex).exec(ua);
    const saVersion = isArray(safariVersion) ? safariVersion[1] : null;
    const browserOffset =
      browserTest && (browserTest.length > 2 && !engineAndVersionPattern.test(browserTest[1]) ? 1 : 0);
    const browserResult = browserTest?.[browserTest.length - 1 - (browserOffset ?? 0)].split('/');
    const browser = browserResult?.[0];
    const version = saVersion ?? browserResult?.[1];

    return { os, browser, version };
  } else if (userAgentData) {
    const os = userAgentData.platform.toLowerCase();
    let platformData: { browser: string; version: string } | undefined;

    // Extract platform brand and version information.
    for (const agentBrand of userAgentData.brands) {
      const agentBrandEntry = agentBrand.brand.toLowerCase();
      const foundBrand = brandList.find(brand => {
        if (agentBrandEntry.includes(brand)) {
          return brand;
        }
        return undefined;
      });
      if (foundBrand) {
        platformData = { browser: foundBrand, version: agentBrand.version };
        break;
      }
    }
    const brandVersionData = platformData ?? {
      browser: unknown,
      version: unknown
    };
    return { os, ...brandVersionData };
  }
  // Log error message if there's a problem.
  console.error(navigatorErrorMessage);

  return {
    // Ignore the strikethrough. Disable linting line if necessary. This is just a fallback

    os: navigator.platform || unknown,
    browser: unknown,
    version: unknown
  };
};

export default detectPlatform;
